import React from 'react'
import classNames from 'classnames'
import {withRouter} from 'react-router-dom'
// State
import {useDispatch} from 'react-redux'
import appSlice from '../../store/slices/aplications'
// Components
import { Grid, Icon} from 'semantic-ui-react'
import DashboardSidebar from '../dashboard/SidebarMenu';
import ApplicationsSidebar from '../applications/SidebarMenu';
import GlossarySidebar from '../glossary/SidebarMenu'
import EndpointSidebar from '../endpoint/SidebarMenu'
//import { glossaryPages } from '../glossary'

import {
  logo,
  logoContainer,
  sidebarContainer,
  activeSidebarItem,
  sidebarContent,
  menuItem,
  menuItemIcon
} from './styles.module.scss'

function SidebarMenu({history, match}) {

  const dispatch = useDispatch()

  const tabs = [
    {
      id: 'dashboard',
      icon: 'dashboard',
      name: 'Dashboard'
    },
    {
      id: 'applications',
      icon: 'window restore outline',
      name: 'Applications'
    },
    {
      id: 'glossary',
      icon: 'inbox',
      name: 'Glossary'
    },
    {
      id: 'endpoint',
      icon: 'book',
      name: 'Endpoint'
    }
  ]


  const selectedTab = tabs.filter((tab, i) => match.url.match(tab.id)).map(obj => obj.id )[0]

  const handleTabClick = tab => {

    if (tab === 'applications') {
      dispatch(appSlice.actions.setCurrentApp(null))
    }

    history.push(`/${tab}`)

  }

  const getSidebarContent = () => {
    switch(selectedTab) {
      case 'applications':
        return <ApplicationsSidebar />
      case 'glossary':
        return <GlossarySidebar />
      case 'endpoint':
        return <EndpointSidebar />
      default:
        return <DashboardSidebar />
    }
  }

  return(
    <div className={sidebarContent}>

      <Grid padded="horizontally" className={sidebarContainer}>

        <Grid.Row>
          <Grid.Column>
            <div className={logoContainer}>
              <img className={logo} src="/images/logo.png" alt="JupiterONE" />
            </div>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row columns={3}>
          { tabs.map( (tab, i) => {
            return (
              <Grid.Column
                textAlign="center"
                key={`tab-${i}`}
                title={tab.name}
                className={ classNames(menuItem, {[activeSidebarItem]: tab.id === selectedTab}) }
                onClick={() => handleTabClick(tab.id)}>
                  <Icon name={tab.icon} size="large" color="grey" className={menuItemIcon} />
              </Grid.Column>
            )
          })}
        </Grid.Row>

      </Grid>

      {getSidebarContent()}

    </div>
  )

}

export default withRouter(SidebarMenu)